import angular from 'angular';
import { AuthService } from './AuthService';
import { AuthInterceptor } from './AuthInterceptor';
import 'components/sharpr/storage/storageModule';
import 'components/sharpr/secureStorage/SecureStorageModule';
import 'components/sharpr/logger/loggerModule';

angular
	.module('sh.auth', ['sh.storage', 'sh.secureStorage', 'sh.logger'])
	.service('Auth', AuthService)
	.factory('AuthInterceptor', AuthInterceptor)
	.config($httpProvider => {
		'ngInject';
		$httpProvider.interceptors.push('AuthInterceptor');
	});
